import { useEffect, useRef, useState } from 'react';
import { rankWith, uiTypeIs, LayoutProps, Layout } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { useScrollSpyContext } from '../../../ScrollSpyContext';
// import { CaretDownOutlinedIcon } from '../../../../../icons/CaretDownOutlinedIcon';
// import { CaretUpOutlinedIcon } from '../../../../../icons/CaretUpOutlinedIcon';
import {
  getElements,
  getLabel,
  getControlsCount,
} from '../../../../../utils/DynamicForms';

import './style.scss';
// import { FilteredUiSchema } from '../../../../../../types/dynamic-forms';

type Props = LayoutProps;

const StepLayout = (props: Props) => {
  const scrollSpyContext = useRef(useScrollSpyContext());
  const ref = useRef<HTMLDivElement | null>(null);
  const [isOpened, setIsOpened] = useState(true);

  useEffect(() => {
    if (!ref.current) return;

    scrollSpyContext.current.registerElement({
      name: getLabel(props.uischema),
      element: ref.current,
    });
  }, [ref, props.uischema, isOpened]);

  const controlsCount = getControlsCount(props.uischema as Layout);

  return (
    <div className="tru-layout-step" ref={ref}>
      <div
        className="step-header-container"
        onClick={() => setIsOpened(!isOpened)}
      >
        <h1 className="step-header">
          <span>{getLabel(props.uischema)}</span>

          {/* {(props.uischema as FilteredUiSchema).isFiltered ? (
            <span>{' (' + controlsCount + ')'}</span>
          ) : null} */}

          {/* <span className="arrow">
            {isOpened ? <CaretUpOutlinedIcon /> : <CaretDownOutlinedIcon />}
          </span> */}
        </h1>
      </div>

      <div
        className={!isOpened || !controlsCount ? 'collapsed-item' : ''}
        hidden={!isOpened || !controlsCount}
      >
        {getElements(props.uischema).map((element, index) => (
          <ResolvedJsonFormsDispatch
            {...props}
            uischema={element}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export const StepLayoutEntry = {
  tester: rankWith(1, uiTypeIs('StepLayout')),
  renderer: withJsonFormsLayoutProps(StepLayout),
};
